import r from"graphql-tag";import{CircleRsvpFragmentDoc as a,CircleRsvpBaseFragmentDoc as c,CircleSessionFragmentDoc as i,CircleFacilitatorFragmentDoc as o}from"./fragments.generated.es.js";import*as n from"@apollo/react-hooks";const s={},u=r`
    query GetCircleRsvps($first: Int, $last: Int, $afterDateTime: DateTime, $beforeDateTime: DateTime) {
  circleRsvps(
    first: $first
    last: $last
    afterDateTime: $afterDateTime
    beforeDateTime: $beforeDateTime
  ) {
    ... on CirclePermissionDeniedError {
      message
    }
    ... on CircleRsvpCollection {
      edges {
        node {
          ...CircleRsvp
        }
      }
    }
  }
}
    ${a}
${c}
${i}
${o}`;function $(e){const t={...s,...e};return n.useQuery(u,t)}function f(e){const t={...s,...e};return n.useLazyQuery(u,t)}const p=r`
    query getCirclesRsvp($id: ID!) {
  circleRsvp(id: $id) {
    ...CircleRsvp
  }
}
    ${a}
${c}
${i}
${o}`;function D(e){const t={...s,...e};return n.useQuery(p,t)}function h(e){const t={...s,...e};return n.useLazyQuery(p,t)}const l=r`
    mutation createUnauthenticatedRsvp($data: CircleCreateUnauthenticatedRsvpDataInput!) {
  circleCreateUnauthenticatedRsvp(data: $data) {
    __typename
    ... on CircleRsvpSuccessful {
      rsvpId
    }
    ... on CircleProcessingError {
      message
    }
    ... on CircleValidationError {
      message
    }
    ... on CircleSessionAlreadyStartedError {
      message
    }
  }
}
    `;function y(e){const t={...s,...e};return n.useMutation(l,t)}const v=r`
    mutation createAuthenticatedRsvp($data: CircleCreateAuthenticatedRsvpDataInput!) {
  circleCreateAuthenticatedRsvp(data: $data) {
    __typename
    ... on CircleRsvpSuccessful {
      rsvpId
    }
    ... on CircleProcessingError {
      message
    }
    ... on CircleValidationError {
      message
    }
    ... on CircleSessionAlreadyStartedError {
      message
    }
  }
}
    `;function g(e){const t={...s,...e};return n.useMutation(v,t)}const d=r`
    mutation cancelUnauthenticatedRsvp($rsvpId: ID!, $token: String!) {
  circleCancelUnauthenticatedRsvp(rsvpId: $rsvpId, rsvpEditToken: $token) {
    ... on CircleRsvpCancellationSuccessful {
      rsvpState
    }
  }
}
    `;function I(e){const t={...s,...e};return n.useMutation(d,t)}const C=r`
    mutation cancelAuthenticatedRsvp($rsvpId: ID!) {
  circleCancelAuthenticatedRsvp(rsvpId: $rsvpId) {
    ... on CircleRsvpCancellationSuccessful {
      rsvpState
    }
  }
}
    `;function A(e){const t={...s,...e};return n.useMutation(C,t)}export{C as CancelAuthenticatedRsvpDocument,d as CancelUnauthenticatedRsvpDocument,v as CreateAuthenticatedRsvpDocument,l as CreateUnauthenticatedRsvpDocument,u as GetCircleRsvpsDocument,p as GetCirclesRsvpDocument,A as useCancelAuthenticatedRsvpMutation,I as useCancelUnauthenticatedRsvpMutation,g as useCreateAuthenticatedRsvpMutation,y as useCreateUnauthenticatedRsvpMutation,f as useGetCircleRsvpsLazyQuery,$ as useGetCircleRsvpsQuery,h as useGetCirclesRsvpLazyQuery,D as useGetCirclesRsvpQuery};
//# sourceMappingURL=rsvp.generated.es.js.map
